import React from 'react';
import { Music, Disc, Star } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const Countdown = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-gradient-to-r from-gold-500/10 via-teal-900/30 to-gold-500/10 backdrop-blur-sm border border-gold-500/30 rounded-2xl p-6 mb-8">
      <div className="text-center space-y-3">
        <div className="flex items-center justify-center gap-2">
          <Star size={20} className="text-gold-400 fill-gold-400" />
          <span className="text-gold-400 font-bold uppercase tracking-widest text-sm">Out Now</span>
          <Star size={20} className="text-gold-400 fill-gold-400" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-teal-50">
          The Gordon Principle
        </h2>
        <p className="text-teal-200 text-sm">
          21 tracks of soulful originals — available now
        </p>
        <div className="flex items-center justify-center gap-3 pt-2">
          <button
            onClick={() => navigate('/store')}
            className="bg-gold-500 hover:bg-gold-600 text-black px-6 py-2 rounded-full font-bold text-sm transition-all duration-200 hover:scale-105 flex items-center gap-2"
          >
            <Disc size={16} />
            Buy Now
          </button>
          <button
            onClick={() => navigate('/music')}
            className="bg-teal-800/50 hover:bg-teal-700/50 text-teal-100 px-6 py-2 rounded-full font-medium text-sm transition-all duration-200 border border-teal-700/50 flex items-center gap-2"
          >
            <Music size={16} />
            Listen
          </button>
        </div>
      </div>
    </div>
  );
};
